module.exports = __webpack_public_path__ + "static/media/intro_background.a1cbe493.jpg";